import React, { useState } from 'react';
import { ChevronDown, ChevronUp, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { faqData } from '../mock';
import SEO from '../components/SEO';

const FAQ = () => {
  const [openItems, setOpenItems] = useState(new Set([1])); // Premier item ouvert par défaut
  
  // Préparer les données FAQ pour le Schema
  const faqSchemaData = faqData.map(item => ({
    question: item.question,
    answer: item.answer
  }));

  const toggleItem = (id) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems.has(id)) {
      newOpenItems.delete(id);
    } else {
      newOpenItems.add(id);
    }
    setOpenItems(newOpenItems);
  };

  return (
    <div className="pt-20">
      <SEO 
        title="FAQ - Questions Fréquentes | Conseil Financier Suisse"
        description="Réponses à vos questions sur le 3ème pilier, fiscalité, retraite, hypothèques et assurances en Suisse. Optimisez votre prévoyance avec ATOM Group."
        keywords="faq conseil financier, questions 3ème pilier, fiscalité suisse, retraite anticipée, hypothèque suisse, assurance maladie"
        canonical="/faq"
        faq={faqSchemaData}
      />
      
      {/* Hero */}
      <section className="py-20">
        <div className="container">
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold heading-display text-white mb-6">
              Questions fréquentes
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Trouvez rapidement les réponses aux questions les plus courantes sur nos services
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Accordion */}
      <section className="pb-20">
        <div className="container max-w-4xl mx-auto">
          <div className="space-y-4">
            {faqData.map((item) => {
              const isOpen = openItems.has(item.id);
              return (
                <div key={item.id} className="glass rounded-2xl overflow-hidden">
                  <button
                    onClick={() => toggleItem(item.id)}
                    className="w-full p-6 text-left flex items-center justify-between hover:bg-white/5 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-white pr-4">
                      {item.question}
                    </h3>
                    <div className="flex-shrink-0">
                      {isOpen ? (
                        <ChevronUp size={24} className="text-blue-300" />
                      ) : (
                        <ChevronDown size={24} className="text-blue-300" />
                      )}
                    </div>
                  </button>
                  
                  <div className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}>
                    <div className="px-6 pb-6">
                      <div className="h-px bg-gradient-to-r from-transparent via-gray-600 to-transparent mb-6"></div>
                      <p className="text-gray-300 leading-relaxed">
                        {item.answer}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* CTA Section */}
          <div className="mt-16 text-center">
            <div className="glass p-8 rounded-3xl">
              <div className="w-16 h-16 bg-blue-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <MessageCircle size={32} className="text-white" />
              </div>
              <h2 className="text-2xl font-bold heading-display text-white mb-4">
                Vous ne trouvez pas votre réponse ?
              </h2>
              <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
                Notre équipe est là pour répondre à toutes vos questions spécifiques. 
                Contactez-nous pour un entretien personnalisé et gratuit.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/contact" className="btn-glass btn-primary px-8 py-3">
                  Poser une question
                </Link>
              </div>
            </div>
          </div>

          {/* Categories d'aide supplémentaires */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="glass p-6 rounded-2xl text-center">
              <h3 className="text-lg font-semibold text-white mb-3">
                Questions sur l'assurance
              </h3>
              <p className="text-gray-300 text-sm mb-4">
                Couvertures, primes, sinistres
              </p>
              <Link to="/assurances" className="text-blue-300 text-sm hover:text-blue-200">
                En savoir plus →
              </Link>
            </div>

            <div className="glass p-6 rounded-2xl text-center">
              <h3 className="text-lg font-semibold text-white mb-3">
                Questions fiscales
              </h3>
              <p className="text-gray-300 text-sm mb-4">
                Optimisation, déductions, succession
              </p>
              <Link to="/fiscalite" className="text-blue-300 text-sm hover:text-blue-200">
                En savoir plus →
              </Link>
            </div>

            <div className="glass p-6 rounded-2xl text-center">
              <h3 className="text-lg font-semibold text-white mb-3">
                Questions retraite
              </h3>
              <p className="text-gray-300 text-sm mb-4">
                3 piliers, LPP, rachat
              </p>
              <Link to="/retraite" className="text-blue-300 text-sm hover:text-blue-200">
                En savoir plus →
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;